import { createFileRoute, redirect } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { useStudioStore } from '~entities/studios/model/studio-store';
import { UserRoles } from '~entities/users';

import { FormSubmissionsPage } from '~features/form-submissions';
import { getFormConfigsOptions } from '~features/form-submissions/api/get-form-configs';

import { checkMinRoleValue } from '~shared/utils/role-guard';

function RouteComponent() {
  return <FormSubmissionsPage />;
}

export const Route = createFileRoute('/_auth/_layout/form-submissions')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }

    const studioId = useStudioStore.getState().currentStudioId;
    if (studioId) {
      await queryClient.ensureQueryData(getFormConfigsOptions(studioId));
    }

    return {
      maxAge: 60 * 1000,
    };
  },
  component: RouteComponent,
});
